import React from 'react';

import { ILink } from 'utils/types';

import s from './People.module.scss';

type Props = {
  email: string;
  phonenumber: string;
  linkedin: ILink;
};

export const PeopleInfo = ({ email, phonenumber, linkedin }: Props) => {
  if (!email && !phonenumber && !linkedin) {
    return null;
  }

  return (
    <ul className={s.peopleInfo}>
      {email && (
        <li className={s.peopleInfo__item}>
          <a className={s.peopleInfo__link} href={`mailto:${email}`}>
            {email}
          </a>
        </li>
      )}
      {phonenumber && (
        <li className={s.peopleInfo__item}>
          <a className={s.peopleInfo__link} href={`tel:${phonenumber}`}>
            {phonenumber}
          </a>
        </li>
      )}
      {linkedin && (
        <li className={s.peopleInfo__item}>
          <a className={s.peopleInfo__link} href={linkedin.href}>
            LinkedIn
          </a>
        </li>
      )}
    </ul>
  );
};
